import { render, staticRenderFns } from "./GlobalHomeSrWrapper.vue?vue&type=template&id=3e64b418&scoped=true"
import script from "./GlobalHomeSrWrapper.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalHomeSrWrapper.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GlobalHomeSrWrapper.vue?vue&type=style&index=0&id=3e64b418&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e64b418",
  null
  
)

export default component.exports